export const PLAYSTORE_LINK = "https://play.google.com/store/apps/details?id=com.kwikset.multifamily";
export const APPSTORE_LINK = "https://apps.apple.com/us/app/kwikset-unite/id6449597135";